import { useEffect, useState } from 'react';

export function useGetUserInfo(userId) {
  const [user, setUser] = useState({});

  const updateUser = (data) => {
    setUser(prevState => ({ ...prevState, ...data}));
  };

  useEffect(() => {
    const doFetch = async () => {
      const d = await fetch(`/api/v1/users/${userId}`);
      const data = await d.json();
      setUser(data['user']);
    };
    doFetch();
    // eslint-disable-next-line
  }, []);
  return [user, updateUser];
}
